import Vue from 'vue'
import {
    LIST,
    LIST_NUM,
    WHERE,
    CACHE_DATA,
    PER_NUM,
    CURRENT,
    HANDOUT_SUCCESS,
    HANDOUT_RESULT
} from '@/store/mutation-types'

const accounts = {
    state: {
        // //主题
        // // theme: "dark",
        // //当前客户信息
        // currentCustInfo: {
        //     id: '',
        //     owner: 'defaultOwner',
        //     mobile: 'defaultMobilel'
        // },
        // //电销业务客户信息
        // ESPCustInfo: {
        //     id: '',
        //     owner: 'defaultOwner',
        //     mobile: 'defaultMobilel'
        // },
        // ESPCIisNext: false,
        // id: 0,
        // owner: 'xiao',
        // mobile: '',
        // //电销模式加载样式状态管理
        // spBusiness: false,
        // spTrackRecord: false,
        // spCalculatePrice: false,
        // //分发中的筛选条件列表
        // list: [],
        // //客户资料查询条件
        // condition: {
        //     where: [],
        //     orderby: '',
        //     order: '',
        //     page: ''
        // }
        //分发中的筛选条件列表
        list: [],
        //名单数
        listNum:0,
        //查询条件
        where:[],
        cacheData:{},
        perNum:'',
        current:0,
        handoutSuccess:false,
        handoutResult:{}
    },
    mutations: {
        // THEME:(state, theme) => {
        //     state.theme = theme;
        // },
        // CURRENT_CUST_INFO:(state, { id = '', owner = '', mobile = '' }) => {
        //     state.currentCustInfo = {
        //         id,
        //         owner,
        //         mobile
        //     };
        //     localStorage.setItem('currentCustInfo', JSON.stringify(state.currentCustInfo))
        // },
        LIST: (state, list) => {
            state.list = list;
        },
        LIST_NUM:(state,listNum) => {
            state.listNum = listNum
        },
        WHERE:(state,where) => {
            state.where = where
        },
        CACHE_DATA:(state,cacheData) => {
            state.cacheData = cacheData
        },
        PER_NUM:(state,perNum) => {
            state.perNum = perNum
        },
        CURRENT:(state,current) => {
            state.current = current
        },
        HANDOUT_SUCCESS: (state, handoutSuccess) => {
            state.handoutSuccess = handoutSuccess
        },
        HANDOUT_RESULT: (state, handoutResult) => {
            state.handoutResult = handoutResult
        }
        // CURRENT_CUST_INFO: (state, currentCustInfo) => {
        //     state.currentCustInfo = currentCustInfo
        //     // localStorage.setItem('currentCustInfo', JSON.stringify(state.currentCustInfo))
        //     Vue.ls.set(CURRENT_CUST_INFO, currentCustInfo)
        // },
    },
    actions: {
        setList: ({ commit }, list) => {
            commit('LIST', list)
        },
        setListNum:({commit},listNum) => {
            commit('LIST_NUM',listNum)
        },
        setWhere:({commit},where) => {
            commit('WHERE',where)
        },
        setCacheData:({commit},cacheData) => {
            commit('CACHE_DATA',cacheData)
        },
        setPerNum:({commit},perNum) => {
            commit('PER_NUM',perNum)
        },
        setCurrent:({commit},current) => {
            commit('CURRENT',current)
        },
        setHandoutSuccess: ({ commit }, handoutSuccess) => {
            commit('HANDOUT_SUCCESS', handoutSuccess)
        },
        setHandoutResult:({commit},handoutResult) => {
            commit('HANDOUT_RESULT',handoutResult)
        }
        // setCurrentCustInfo: ({ commit }, currentCustInfo) => {
        //     commit('CURRENT_CUST_INFO', currentCustInfo)
        // },
        // setESPCustInfo: ({ commit }, ESPCustInfo) => {
        //     commit('ESP_CUST_INFO', ESPCustInfo)
        // },
        // setESPCIisNext: ({ commit }, ESPCIisNext) => {
        //     commit('ESPCI_IS_NEXT', ESPCIisNext)
        // },
        // setID: ({ commit }, id) => {
        //     commit('ID', id)
        // },
        // setOwner: ({ commit }, owner) => {
        //     commit('OWNER', owner)
        // },
        // setMobile: ({ commit }, mobile) => {
        //     commit('MOBILE', mobile)
        // },
        // setSpBusiness: ({ commit }, spBusiness) => {
        //     commit('ESP_SP_BUSINESS', spBusiness)
        // },
        // setSpTrackRecord: ({ commit }, spTrackRecord) => {
        //     commit('MOBILE', spTrackRecord)
        // },
        // setSpCalculatePrice: ({ commit }, spCalculatePrice) => {
        //     commit('ESP_SP_CALCULATE_PRICE', spCalculatePrice)
        // },
        // setList: ({ commit }, list) => {
        //     commit('LIST', list)
        // },
        // setCondition: ({ commit }, condition) => {
        //     commit('CONDITION', condition)
        // },
    }
}

export default accounts


// WEBPACK FOOTER //
// ./src/store/modules/handout.js